import { BioProvider } from './BioContext';
import { SkillsProvider } from './SkillsContext';
import { ProjectsProvider } from './ProjectsContext';
import { ExperiencesProvider } from './ExperiencesContext';
import { EducationProvider } from './EducationContext';
import { TestimonialsProvider } from './TestimonialsContext';
import { TranslationsProvider } from './TranslationsContext';

export const FirestoreDataProvider = ({ children }) => {
  return (
    <TranslationsProvider>
      <BioProvider>
        <SkillsProvider>
          <ProjectsProvider>
            <ExperiencesProvider>
              <EducationProvider>
                <TestimonialsProvider>{children}</TestimonialsProvider>
              </EducationProvider>
            </ExperiencesProvider>
          </ProjectsProvider>
        </SkillsProvider>
      </BioProvider>
    </TranslationsProvider>
  );
};
